import { Logger } from '@superbet-group/web.lib.utilities';
import { AsyncComponent } from 'vue';

import {
    loadAsyncComponent,
    ComponentWithProps,
    ComponentWithPropsExport,
} from '@app/utils/loadAsyncComponent';
import FederationFallback from '@src/federations/FederationFallback.vue';

/**
 * Renders federation fallback while waiting for importer to load.
 */
export function getFederationComponent<Props>(
    importer: () => Promise<ComponentWithPropsExport<Props>>,
    logger?: Logger,
): AsyncComponent {
    return loadAsyncComponent(
        importer,
        FederationFallback as ComponentWithProps<Props>,
        logger,
    );
}
